import Participants from "./Participants"
import SharedLink from "./SharedLink"
import SuggestedPeople from "./SuggestedPeople"
import Timezone from "./Timezone"

import "./index.scss"

// People Card Detail-Groups spec (Notion "People Card" d45923fee2264c559a5512601920958c),
// restructured 2026-07-05 per QJ concept correction: the EXPANDED body is a vertical stack of
// DETAIL GROUPS, 16px spacing (this container's `gap: 16px`, index.scss), each a distinct
// card/section, no repetition of the collapsed row's own content, IN THIS ORDER:
//   1. Info + People's Activity -- Participants (stats summary + per-person activity rows, the
//      viewer's own row self-pinned at top carrying the inline attendance control -- REPLACES
//      the old separate "My Status" (YourStatus) block, which no longer exists as its own
//      group: status now changes inline, on the self row, not in a standalone section).
//   1.5. Suggested people -- SuggestedPeople (A7, QJ 2026-07-07): deterministic ranked
//      candidates NOT already participants, each with a one-tap Add + a why-chip. Placed right
//      after Participants (who's already here) since it's the natural next question ("who else
//      should be here"); renders nothing when there are no candidates (honest-empty).
//   2. Shared Link   -- SharedLink
//   3. Join Requests -- only when there are any; web has no join-request list data source at
//                       all today (grep across the repo turns up only the settings TOGGLE that
//                       enables approval, never an actual pending-requests list/selector) -- per
//                       spec ("otherwise render nothing -- do not fabricate") this group is
//                       omitted rather than faked. Re-add here the moment a real data source
//                       exists.
//   4. Time Zones      -- Timezone, LAST, multi-TZ only (unchanged placement/gating)
// The standalone "Activity Stream" section (generic, teeup-wide event lines) is gone -- it was
// the wrong concept for this card; its raw messages are now the material for each person's own
// activity flow inside Participants instead of a second, duplicate chronological list
// (Conversation > All activity already owns the teeup-wide record).
const Content = ({ people, isMultiTimezone }) => {
  return (
    <div className="people-content">
      <Participants people={people} />

      <SuggestedPeople />

      <SharedLink />

      {isMultiTimezone && <Timezone people={people} />}
    </div>
  )
}

export default Content
